export function isAbsoluteURL(urlStr: string) {
  return urlStr.indexOf('http://') === 0 || urlStr.indexOf('https://') === 0;
}

const OWNER_SUBDOMAIN_PREFIX = 'owner.';

/**
 * Guest portal lives on the same domain as the owner portal with the `guest` subdomain.
 * Prepending `guest.` to the full hostname is wrong for hosts like `owner.example.com`
 * (would yield `guest.owner.example.com`). Replace the `owner.` prefix instead.
 */
export function guestPortalHostname(hostname: string): string {
  if (hostname.startsWith(OWNER_SUBDOMAIN_PREFIX)) {
    return `guest.${hostname.slice(OWNER_SUBDOMAIN_PREFIX.length)}`;
  }
  return `guest.${hostname}`;
}

export function guestPortalOrigin(hostname: string): string {
  return `https://${guestPortalHostname(hostname)}`;
}

export function isExternalURL(urlStr: string) {
  //WARNING: This will not work as expected on localhost!d

  //NOTE: This should decide whether a given url is internal. It does NOT validate the url, or even confirm
  //      whether an internal route exists. Use with caution.
  //
  // Example external:
  // "wikipedia.org"
  // "https://wikipedia.org"
  //
  // Example internal:
  // "owner.mrr.com/profile"
  // "https://owner.mrr.com/profile"

  const urlIsAbsolute = isAbsoluteURL(urlStr);

  let hostOfUrlStr = '';

  if (!urlIsAbsolute) {
    return false;
  }

  hostOfUrlStr = new URL(urlStr).host;

  const currentHost = window.location.host;

  const urlIsExternal = !hostOfUrlStr.includes(currentHost);

  // console.warn('isExternalURL >>> ',
  // 'urlStr',urlStr,
  // 'urlIsAbsolute',urlIsAbsolute,
  // 'hostOfUrlStr',hostOfUrlStr,
  // 'currentHost',currentHost,
  // 'urlIsExternal',urlIsExternal);

  return urlIsExternal;
}
